import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface NotificationCenterStoreState {
  notifications: any[];
  selectedNotifications: any[];
}
export default {
  state: {
    notifications: [],
    selectedNotifications: [],
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setSelectedNotifications(state, payload) {
      state.selectedNotifications = payload;
    },
  },
  actions: {
    /* tslint:disable-next-line */
    getNotifications(context: ActionContext<NotificationCenterStoreState, RootStoreState>) {
      // context.commit('startLoading', null, { root: true });
      const endpoint = 'notificationnew/get-all';
      return ApiServiceWrapper.get(endpoint);
    },
    pinNotification(context: ActionContext<NotificationCenterStoreState, RootStoreState>, notificationId) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `notification/pin?notificationid=${notificationId}`;
      return ApiServiceWrapper.post(endpoint);
    },
    unpinNotification(context: ActionContext<NotificationCenterStoreState, RootStoreState>, notificationId) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `notification/unpin?notificationid=${notificationId}`;
      return ApiServiceWrapper.post(endpoint);
    },
    deleteNotification(context: ActionContext<NotificationCenterStoreState, RootStoreState>, notificationId) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `notification/delete?notificationid=${notificationId}`;
      return ApiServiceWrapper.delete(endpoint);
    },
  },
  getters: {
    getNotifications: state => state.notifications,
    getSelectedNotifications: state => state.selectedNotifications,
    getSelectedNotificationsCount: state => state.selectedNotifications?.length,
  },
  namespaced: true,
} as Module<NotificationCenterStoreState, RootStoreState>;
